// Third Party Library
import { Badge, Typography } from "antd";

// Constant Library
import { ROOT_CONSTANT, TEMPLATE } from "../../../constants";

// Components Library
import { ButtonLink } from "../../../components";

// Handlers Library
import { filter } from "../../../handlers";

// Service Library
import { TIME } from "../../../services/util";

const { TABLE_EMPLOYER_TITLE, TABLE_EMPLOYER_INDEX, EMPLOYER_STATUS_TITLE } =
  TEMPLATE.EMPLOYER;

const { icon_malaysia } = ROOT_CONSTANT.IMG.ICON.COUNTRY;
const { icon_comment } = ROOT_CONSTANT.IMG.ICON;

const { parseTimeMin } = TIME;
const { searchHDLR, filterHDLR } = filter;
const { Text } = Typography;

export const EMPLOYER_SUMMARY_COL = ({
  func = {},
  redux = {},
  exportState = false,
}) => {
  const { handleSearch, DrawerRemark } = func;
  const { company = {} } = redux;

  return [
    {
      title: TABLE_EMPLOYER_TITLE.EmployerID,
      key: TABLE_EMPLOYER_INDEX.EmployerID,
      width: 180,
      fixed: "left",
      render: (record) => {
        const { memid } = record;
        return exportState ? memid : <>{memid} </>;
      },
      ...searchHDLR.getColumnSearchProps("memid", handleSearch),
    },
    {
      title: TABLE_EMPLOYER_TITLE.Status,
      key: TABLE_EMPLOYER_INDEX.Status,
      fixed: "left",
      render: (record) => {
        const { status } = record;
        const { name, colorTag, bgColor } = EMPLOYER_STATUS_TITLE[status];

        return exportState ? (
          name
        ) : (
          <div
            style={{
              backgroundColor: bgColor,
              display: "inline-block",
              padding: "3px 13px",
              borderRadius: "30px",
            }}
          >
            <Badge
              color={colorTag}
              text={<span style={{ color: colorTag }}>{name}</span>}
            />
          </div>
        );
      },
      filters: filterHDLR.getColumnsFilterStatus(EMPLOYER_STATUS_TITLE),
      onFilter: (value, record) => record.status === value,
    },
    {
      title: TABLE_EMPLOYER_TITLE.Name,
      key: TABLE_EMPLOYER_INDEX.Name,
      width: 200,
      render: (record) => {
        const { name } = record;
        return exportState ? name : <Text>{name}</Text>;
      },
      ...searchHDLR.getColumnSearchProps("name", handleSearch),
      sorter: true
    },
    {
      title: TABLE_EMPLOYER_TITLE.CoName,
      key: TABLE_EMPLOYER_INDEX.CoName,
      render: (record) => {
        const { company_name, coid } = record;

        const comp = `${company_name || ""}${company_name && coid ? " /" : ""}${
          coid || ""
        }`;
        return exportState ? company_name : <Text>{comp}</Text>;
      },
      filters: filterHDLR.getColumnsFilterType(company),
      onFilter: (value, record) => value.includes(record.coid),
      filterSearch: true,
    },
    ...(exportState
      ? [
          {
            title: TABLE_EMPLOYER_TITLE.CoID,
            width: 200,
            render: (record) => {
              const { coid } = record;

              return exportState ? coid : <Text>{coid}</Text>;
            },
            ...searchHDLR.getColumnSearchProps("coid", handleSearch),
          },
        ]
      : []),
    {
      title: TABLE_EMPLOYER_TITLE.Position,
      key: TABLE_EMPLOYER_INDEX.Position,
      render: (record) => {
        const { position } = record;
        return exportState ? position : <>{position}</>;
      },
      ...searchHDLR.getColumnSearchProps("position", handleSearch),
    },
    {
      title: TABLE_EMPLOYER_TITLE.Contact,
      key: TABLE_EMPLOYER_INDEX.Contact,
      render: (record) => {
        const { contact } = record;
        const formattedContact = contact.replace(
          "+60",
          `<img src=${icon_malaysia} alt="Malaysia" style="width: 20px; height: 15px; border-radius: 50%; margin-right: 5px;"/>`
        );
        return exportState ? (
          contact
        ) : (
          <span dangerouslySetInnerHTML={{ __html: formattedContact }} />
        );
      },
      ...searchHDLR.getColumnSearchProps("contact", handleSearch),
    },
    {
      title: TABLE_EMPLOYER_TITLE.Email,
      key: TABLE_EMPLOYER_INDEX.Email,
      render: (record) => {
        const { email } = record;
        return exportState ? email : <>{email}</>;
      },
      ...searchHDLR.getColumnSearchProps("email", handleSearch),
    },
    {
      title: TABLE_EMPLOYER_TITLE.CreatedAt,
      key: TABLE_EMPLOYER_INDEX.CreatedAt,
      render: (record) => {
        const { createdBy, createdBy_name, createdAt } = record;
        const created = `${createdBy_name} /${createdBy}`
        return exportState ? (
          `${created} - ${parseTimeMin(createdAt)}`
        ) : (
          <span>
            {created}
            <br />
            {parseTimeMin(createdAt)}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: TABLE_EMPLOYER_TITLE.UpdatedAt,
      key: TABLE_EMPLOYER_INDEX.UpdatedAt,
      render: (record) => {
        const { updatedBy, updatedBy_name, updatedAt } = record;
        const updated = updatedBy ? `${updatedBy_name} /${updatedBy}` : "-"
        return exportState ? (
          `${updated} - ${parseTimeMin(updatedAt)}`
        ) : (
          <span>
            {updated}
            <br />
            {parseTimeMin(updatedAt)}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: TABLE_EMPLOYER_TITLE.Remarks,
      key: TABLE_EMPLOYER_INDEX.Remarks,
      fixed: "right",
      render: (record) => {
        const { remarkCount } = record;

        return (
          <Badge
            count={remarkCount || 0}
            showZero
            offset={[10, 10]}
            color="#0E2483"
          >
            <ButtonLink
              onClick={() => {
                DrawerRemark(record);
              }}
            >
              <img src={icon_comment} alt="" />
            </ButtonLink>
          </Badge>
        );
      },
    },
  ];
};
